import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXTourPromotions_SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className="span_1_of_6 bg-f7f">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={60}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 10px 0 43px"
                data-mobilemargin="0 15px 0 15px"
              >
                <div className="themesflat-headings style-2 clearfix">
                  <div className="sup-heading">
                    POPRATNI TURISTIČKI SADRŽAJI
                  </div>
                  <h2 className="heading font-size-28 line-height-39">
                    CITYX TOUR &#38; PASS PROMOCIJA
                  </h2>
                  <div className="sep has-width w80 accent-bg margin-top-20 clearfix" />
                  <p className="margin-top-33 line-height-24">
                    Gdje jesti, gdje iznajmiti bicikl ili auto, a gdje kupiti
                    suvenir? Na najčešća pitanja turista, CityX Tour &#38; Pass
                    ima odgovor! ;-) U sklopu aplikacije, u dijelu Promocija,
                    nudimo svima koji se bave uslužnom djelatnošću promociju
                    istih. Bilo da želite oglasiti hotel, restoran, uslugu najma
                    bicikala, rent-a-car, suvenirnicu i slično, na pravom ste
                    mjestu!
                  </p>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={56}
                data-mobile={56}
                data-smobile={56}
              />
            </div>
            <div
              className="span_1_of_6 half-background "
              style={{
                backgroundImage:
                  "url(../assets/img/apps/cityx-tour-pass-promotions.jpg",
                backgroundPosition: "left center",
              }}
            ></div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              ŠTO JE POTREBNO ZA UKLJUČENJE U CITYX TOUR &#38; PASS?
            </h5>
            <p>
              Uključivanje u aplikaciju je potpuno besplatno, a mi smo tu da se
              maksimalno približimo vašim željama i potrebama. Konkretno vam
              možemo ponuditi uvrštenje vaše ponude u sklopu promocija
              (fotografije i tekst), kao i ekskluzivnu ponudu CityX paketa za
              goste (turiste) u obliku popusta kojeg realiziraju uz kod za
              popust. Slobodno nam se javite putem maila (niže na stranici) kako
              bi vam pobliže predstavili sve mogućnosti suradnje.
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <div className="item">
              <div className="inner">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={10}
                  data-mobile={10}
                  data-smobile={10}
                />
                <h5 className="title">
                  ZAŠTO SE UKLJUČITI U CITYX TOUR &#38; PASS?
                </h5>
                <p>
                  Uz brojnu ponudu turističkih atrakcija i usluga turističkih
                  vodiča, u pravom trenutku našim korisnicima kao "upsale" model
                  nudimo vašu ponudu. Ovo nisu reklame koje samo "iskoče" več
                  dobro osmišljena ponuda lokacijski i interesno povezana s
                  ponašanjem kupca. Po izuzetno povoljnim uvjetima dobivate:
                </p>
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={8}
                  data-mobile={8}
                  data-smobile={8}
                />
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Unos Vaše usluge sa bitnim informacija
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Opis usluge, kontakte i lokaciju
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">Ispis radno vrijeme</span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">Online rezervacije</span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Prikazivanje ponude unutar "upsale" kanala
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Sudjelovanje pod last minute / akcije
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={0}
                data-mobile={0}
                data-smobile={35}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 0 0 11px"
                data-mobilemargin="0 0 0 0"
              >
                <div className="inner pd35 bg-ffc">
                  <h5 className="title text-white line-height-24 padding-left-7">
                    PREUZMITE PREZENTACIJSKE MATERIJALE ZA CITYX TOUR&#38;PASS
                  </h5>
                  <br />
                  <div
                    className="themesflat-spacer clearfix"
                    data-desktop={16}
                    data-mobile={16}
                    data-smobile={16}
                  />
                  <div className="button-wrap has-icon icon-right size-14">
                    <p
                      href="#"
                      className="themesflat-button bg-white color-333 w100 font-weight-400 no-letter-spacing pd26 "
                      style={{ opacity: ".5" }}
                    >
                      <span>
                        U PRIPREMI
                        <span className="icon">
                          <i className="fa fa-file-pdf-o" />
                        </span>
                      </span>
                    </p>
                  </div>

                  <div
                    className="themesflat-spacer clearfix"
                    data-desktop={6}
                    data-mobile={6}
                    data-smobile={6}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              KAKO SE UKLJUČITI U CITYX TOUR &#38; PASS PROMOCIJE?
            </h5>
            <p>
              Javite nam se telefonski ili pošaljite zahtjev za kontaktom preko
              forme.
            </p>
            <div className="flat-content-wrap style-2 clearfix">
              <p style={{ padding: "0px" }}>
                <iframe
                  src="https://forms.monday.com/forms/embed/3699c1114b3775c5b4370be9337f7ad4?r=use1"
                  width={"100%"}
                  style={{
                    width: "200%",
                    height: "1000px",
                  }}
                ></iframe>
              </p>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CityXTourPromotions_SiteContent;
